// extracted by mini-css-extract-plugin
export default {"main":"LoginPage_main__wr8IE","wrapper":"LoginPage_wrapper__ewWJj","title":"LoginPage_title__RBt-o"};